// @flow

import React, { useState } from 'react'
import './AppProfileFilter.css'

type Props = {
  changeFilter: Function,
  currentFilter: Function,
  profiles: Array
}

function AppProfileFilter ({ changeFilter, currentFilter, profiles }: Props) {
  const filter = currentFilter && Array.isArray(currentFilter.profiles) ? currentFilter.profiles : []
  const [selected, setSelected] = useState(filter)

  const totalProfiles = profiles.length + 1
  const initialItemsToShow = totalProfiles <= 10 ? totalProfiles : 10
  const [itemsToShow, setItemsToShow] = useState(initialItemsToShow)

  const handleClick = (id) => {
    if (Array.isArray(id)) {
      setSelected([])
      changeFilter(Object.assign({}, currentFilter, { profiles: id }))
    } else {
      if (selected.indexOf(id) >= 0) {
        const copyArray = Array.from(selected)
        copyArray.splice(selected.indexOf(id), 1)
        setSelected(copyArray)
        changeFilter(Object.assign({}, currentFilter, { profiles: copyArray }))
      } else {
        setSelected([...selected, id])
        changeFilter(Object.assign({}, currentFilter, { profiles: [...selected, id] }))
      }
    }
  }

  const handleSeeMore = (showMore) => {
    const items = showMore ? totalProfiles : 10
    setItemsToShow(items)
  }

  const getData = () => {
    const list = []
    list.push(<span key='' className={selected.length === 0 ? 'selected' : ''} onClick={() => handleClick([])}>All App Profiles</span>)

    const data = profiles.filter((i) => {
      return i._id
    }).map((instance) => {
      return <span key={instance._id} className={selected.indexOf(instance._id) >= 0 ? 'selected' : ''} onClick={(e) => handleClick(instance._id)}>{instance.name} </span>
    })

    return list.concat(data)
  }

  const data = getData()

  return (
    <div className='Header'>
      <div className='FilterByRow'>
        <div className='FilterByColumn'>
          <div>
            <span className='HeaderText'>Filter by App Profiles</span>
          </div>
          <div className='FilterByContent AppProfileFilterContent'>
            <div className='FilterByRow'>
              <div className='FilterByColumn'>
                {data.slice(0, itemsToShow)}
                {itemsToShow < totalProfiles && (
                  <span className='SeeMoreButton' onClick={() => handleSeeMore(true)}>See More...</span>
                )}
                {(itemsToShow === totalProfiles && totalProfiles > 10) && (
                  <span className='SeeMoreButton' onClick={() => handleSeeMore(false)}>See Less...</span>
                )}
              </div>
            </div>
            <hr />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AppProfileFilter
